import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, OnInit } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';

interface TelaControleAcesso {
  codigo: string;
  nome: string;
  rota: string;
  modulo: string;
  ativo: string;
  iconURL?: string;
  id?: string | number;
  descricao?: string;
  contexto?: string;
  temFilhos?: string;
  controle?: string;
  resourceID?: string;
  nivel?: number;
  tipoItem?: 'MODULO' | 'PASTA' | 'TELA';
}

interface PermissaoControleAcesso {
  id?: number;
  codigoTela: string;
  nomeTela: string;
  tipoAlvo: 'GRUPO' | 'USUARIO';
  codigoAlvo: string;
  nomeAlvo: string;
  visualizar: boolean;
  incluir: boolean;
  alterar: boolean;
  excluir: boolean;
  ativo: string;
  agrupamento?: string;
  fotoUrl?: string;
  _fotoErro?: boolean;
}

interface AlvoAcesso {
  id: number | string;
  descricao: string;
  tipo: 'usuario' | 'grupo';
  agrupamento?: string;
}

interface AcessoDisponivel {
  sigla: string;
  idAcesso: string;
  descricao: string;
  grupo: boolean;
  repassar: boolean;
  permissao: boolean;
  especial: boolean;
  podeAlterar: boolean;
}

interface UsuarioAcessoModal {
  id: number | string;
  descricao: string;
  tipo: string;
  agrupamento?: string;
  _fotoErro?: boolean;
}

@Component({
  selector: 'app-controle-acessos',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './controle-acessos.component.html',
  styleUrl: './controle-acessos.component.css'
})
export class ControleAcessosComponent implements OnInit {
  carregando = false;
  salvando = false;
  erro = '';
  sucesso = '';
  filtroTela = '';
  filtroPermissao = '';

  modalUsuariosAberto = false;
  modalNovoAcessoAberto = false;
  edicaoAcesso = false;
  modalAvisoAberto = false;
  modalAvisoTitulo = '';
  modalAvisoMensagem = '';
  modalConfirmarExclusaoAberto = false;
  alvoExclusaoPermissao: UsuarioAcessoModal | null = null;
  carregandoUsuariosModal = false;
  filtroUsuarioModal = '';
  usuariosModal: UsuarioAcessoModal[] = [];
  usuariosModalFiltrados: UsuarioAcessoModal[] = [];
  usuariosSelecionados: UsuarioAcessoModal[] = [];


  telasSelecionadas: TelaControleAcesso[] = [];
  telas: TelaControleAcesso[] = [];
  telasNivelAtual: TelaControleAcesso[] = [];
  caminhoTelas: TelaControleAcesso[] = [];
  cacheTelas = new Map<string, TelaControleAcesso[]>();
  carregandoTelas = false;
  carregandoPermissoes = false;
  telaSelecionada: TelaControleAcesso | null = null;
  telaFocoAcesso: TelaControleAcesso | null = null;
  permissoes: PermissaoControleAcesso[] = [];

  alvosAcesso: AlvoAcesso[] = [];
  alvosFiltrados: AlvoAcesso[] = [];
  dropdownAlvosAberto = false;
  buscandoAlvos = false;
  private buscaAlvoTimer: ReturnType<typeof setTimeout> | null = null;

  acessosDisponiveis: AcessoDisponivel[] = [];
  private readonly imagensBaseUrl = 'https://snkbrp01782.ativy.com';

  form = {
    codigoTela: '',
    tipoAlvo: 'GRUPO' as 'GRUPO' | 'USUARIO',
    codigoAlvo: '',
    nomeAlvo: '',
    visualizar: true,
    incluir: false,
    alterar: false,
    excluir: false,
    ativo: 'S'
  };

  constructor(private readonly gateway: SankhyaGatewayService) {}

  async ngOnInit(): Promise<void> {
    await this.carregar();
  }

  abrirModalNovoAcesso(): void {
    if (!this.telaSelecionada) {
      this.erro = 'Selecione uma tela antes de criar um novo acesso.';
      return;
    }

    this.edicaoAcesso = false;
    this.form.codigoAlvo = '';
    this.form.nomeAlvo = '';
    this.usuariosSelecionados = [];
    this.modalNovoAcessoAberto = true;
  }

  fecharModalNovoAcesso(): void {
    this.modalNovoAcessoAberto = false;
    this.edicaoAcesso = false;
    this.modalConfirmarExclusaoAberto = false;
    this.alvoExclusaoPermissao = null;
  }

  async carregar(): Promise<void> {
    this.carregando = true;
    this.erro = '';
    this.sucesso = '';

    try {
      const resTelas = await firstValueFrom(this.gateway.listarTelasControleAcesso());

      const bodyTelas: any = (resTelas as any)?.responseBody ?? resTelas;
      const telasSankhya = this.extrairListaTelasSankhya(bodyTelas);

      this.telas = telasSankhya.map((t: any) => this.normalizarTelaSankhya(t, 0));
      this.telasNivelAtual = this.telas;
      this.caminhoTelas = [];
      this.telaSelecionada = null;
      this.telaFocoAcesso = null;
      this.form.codigoTela = '';
      this.cacheTelas.clear();
      this.cacheTelas.set('ROOT', this.telas);
      this.permissoes = [];

      if (!this.telas.length) {
        this.erro = 'Nenhuma tela foi retornada pelo service padrão do Sankhya.';
      }

    } catch (e: any) {
      this.telas = [];
      this.telasNivelAtual = [];
      this.caminhoTelas = [];
      this.telaSelecionada = null;
      this.telaFocoAcesso = null;
      this.form.codigoTela = '';
      this.cacheTelas.clear();
      this.permissoes = [];
      this.erro = e?.message || 'Erro ao carregar as telas pelo service padrão do Sankhya.';
    } finally {
      this.carregando = false;
    }
  }

  private extrairListaTelasSankhya(body: any): any[] {
    if (!body) {
      return [];
    }

    if (Array.isArray(body)) {
      return body;
    }

    if (Array.isArray(body.lista)) {
      return body.lista;
    }

    if (Array.isArray(body.telas)) {
      return body.telas;
    }

    if (Array.isArray(body.json)) {
      return body.json;
    }

    if (body.responseBody) {
      return this.extrairListaTelasSankhya(body.responseBody);
    }

    if (typeof body.json === 'string') {
      return this.parseListaJson(body.json);
    }

    if (body.json && typeof body.json.$ === 'string') {
      return this.parseListaJson(body.json.$);
    }

    if (typeof body === 'string') {
      return this.parseListaJson(body);
    }

    return [];
  }

  private parseListaJson(valor: string): any[] {
    if (!valor || !valor.trim()) {
      return [];
    }

    try {
      const parsed = JSON.parse(valor);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private normalizarTelaSankhya(tela: any, nivel = this.caminhoTelas.length): TelaControleAcesso {
    const id = tela?.id ?? tela?.codigo ?? '';
    const descricao = tela?.descricao ?? tela?.nome ?? '';
    const contexto = tela?.contexto ?? tela?.rota ?? '';
    const temFilhos = String(tela?.temFilhos ?? tela?.TEMFILHOS ?? 'N').toUpperCase();

    return {
      ...tela,

      codigo: String(id),
      nome: descricao,
      rota: contexto || String(id),
      modulo: contexto || 'SANKHYA',
      ativo: 'S',
      iconURL: this.normalizarIconUrl(tela?.iconURL),
      nivel,
      tipoItem: this.tipoItemMenu(temFilhos, nivel),

      id,
      descricao,
      contexto,
      resourceID: tela?.resourceID ?? tela?.resourceId ?? tela?.RESOURCEID ?? '',
      temFilhos,
      controle: tela?.controle ?? '',
      adicional: !!tela?.adicional,
      showInfoTelaPersonalizada: !!tela?.showInfoTelaPersonalizada
    };
  }

  private normalizarIconUrl(iconURL: any): string {
    const imagemPadrao = this.urlSankhya('/integracaoasis/assets/icon.png');

    const url = String(iconURL ?? '').trim();

    if (!url) {
      return imagemPadrao;
    }

    if (url.startsWith('http://') || url.startsWith('https://')) {
      return this.urlSankhya(url);
    }

    return this.urlSankhya(url);
  }

  private urlSankhya(url: string): string {
    const valor = String(url ?? '').trim();

    if (!valor) {
      return '';
    }

    if (valor.startsWith('http://') || valor.startsWith('https://')) {
      const caminho = valor.replace(/^https?:\/\/[^/]+/i, '');
      return `${this.imagensBaseUrl}${caminho.startsWith('/') ? caminho : `/${caminho}`}`;
    }

    return `${this.imagensBaseUrl}${valor.startsWith('/') ? valor : `/${valor}`}`;
  }

  telasFiltradas(): TelaControleAcesso[] {
    const termo = this.filtroTela.trim().toUpperCase();
    if (!termo) return this.telasNivelAtual;
    return this.telasNivelAtual.filter(t =>
      `${t.nome} ${t.rota} ${t.modulo}`.toUpperCase().includes(termo)
    );
  }

  permissoesFiltradas(): PermissaoControleAcesso[] {
    const termo = this.filtroPermissao.trim().toUpperCase();
    if (!termo) return this.permissoes;
    return this.permissoes.filter(p =>
      `${p.nomeTela} ${p.tipoAlvo} ${p.codigoAlvo} ${p.nomeAlvo}`.toUpperCase().includes(termo)
    );
  }

  async selecionarTela(tela: TelaControleAcesso): Promise<void> {
    if (this.temFilhos(tela)) {
      await this.abrirFilhosTela(tela);
      return;
    }

    if (this.telaSelecionadaMultipla(tela)) {
      this.telasSelecionadas = this.telasSelecionadas.filter((item) => item.codigo !== tela.codigo);
      this.telaFocoAcesso = this.telasSelecionadas[this.telasSelecionadas.length - 1] ?? null;
    } else {
      this.telasSelecionadas = [...this.telasSelecionadas, tela];
      this.telaFocoAcesso = tela;
    }

      this.telaSelecionada = this.telasSelecionadas[this.telasSelecionadas.length - 1] ?? null;
      this.form.codigoTela = this.telasSelecionadas.map((item) => item.codigo).join(',');

      if (this.telaSelecionada) {
        const dadosDebug = {
          nome: this.telaSelecionada.nome,
          descricao: this.telaSelecionada.descricao,
          id: this.telaSelecionada.id,
          codigo: this.telaSelecionada.codigo,
          contexto: this.telaSelecionada.contexto,
          rota: this.telaSelecionada.rota,
          resourceID: this.telaSelecionada.resourceID,
          resourceIdUsado: this.resourceIdTela(this.telaSelecionada),
          telaCompleta: this.telaSelecionada
        };
        console.log('[ControleAcessos] Tela selecionada resourceID:', dadosDebug);
      }

      this.form.codigoAlvo = '';
      this.form.nomeAlvo = '';
    this.alvosAcesso = [];
    this.alvosFiltrados = [];
    this.dropdownAlvosAberto = false;

    if (this.telaSelecionada) {
      await this.carregarPermissoesDisponiveisTela(this.telaSelecionada);
      await this.carregarEntidadesAcessoTela(this.telaSelecionada);
    } else {
      this.acessosDisponiveis = [];
      this.permissoes = [];
    }
  }

  async carregarPermissoesDisponiveisTela(tela: TelaControleAcesso): Promise<void> {
    const resourceID = this.resourceIdTela(tela);

    if (!resourceID) {
      this.acessosDisponiveis = [];
      return;
    }

    try {
      const res = await firstValueFrom(
          this.gateway.listarPermissaoAcessoControleAcesso(resourceID, this.form.tipoAlvo)
      );

      const body: any = (res as any)?.responseBody ?? res;

      this.acessosDisponiveis = this.extrairListaTelasSankhya(body).map((item: any) => ({
        sigla: String(item.sigla ?? ''),
        idAcesso: String(item.idAcesso ?? resourceID),
        descricao: String(item.descricao ?? item.sigla ?? ''),
        grupo: this.flag(item.grupo ?? item.GRUPO),
        repassar: this.flag(item.repassar ?? item.REPASSAR),
        permissao: this.flag(item.permissao ?? item.PERMISSAO),
        especial: this.flag(item.especial ?? item.ESPECIAL),
        podeAlterar: item.podeAlterar !== false
      }));

    } catch (e: any) {
      this.acessosDisponiveis = [];
      this.erro = e?.message || 'Erro ao carregar as opções de permissão da tela.';
    }
  }

  async editarPermissaoExistente(permissao: PermissaoControleAcesso): Promise<void> {
    if (!this.telaSelecionada) {
      this.erro = 'Selecione uma tela antes de editar o acesso.';
      return;
    }

    const resourceID = this.resourceIdTela(this.telaSelecionada);

    this.erro = '';
    this.sucesso = '';
    this.form.tipoAlvo = permissao.tipoAlvo;
    this.form.codigoAlvo = permissao.codigoAlvo;
    this.form.nomeAlvo = permissao.nomeAlvo;
    this.edicaoAcesso = true;
    this.usuariosSelecionados = [{
      id: permissao.codigoAlvo,
      descricao: permissao.nomeAlvo,
      tipo: permissao.tipoAlvo === 'USUARIO' ? 'usuario' : 'grupo',
      agrupamento: permissao.agrupamento
    }];
    this.modalNovoAcessoAberto = true;
    this.acessosDisponiveis = [];

    try {
      const res = await firstValueFrom(
          this.gateway.listarPermissaoAcessoControleAcesso(resourceID, permissao.tipoAlvo, permissao.codigoAlvo)
      );

      const body: any = (res as any)?.responseBody ?? res;

      this.acessosDisponiveis = this.extrairListaTelasSankhya(body).map((item: any) => ({
        sigla: String(item.sigla ?? ''),
        idAcesso: String(item.idAcesso ?? resourceID),
        descricao: String(item.descricao ?? item.sigla ?? ''),
        grupo: this.flag(item.grupo ?? item.GRUPO),
        repassar: this.flag(item.repassar ?? item.REPASSAR),
        permissao: this.flag(item.permissao ?? item.PERMISSAO),
        especial: this.flag(item.especial ?? item.ESPECIAL),
        podeAlterar: item.podeAlterar !== false
      }));

    } catch (e: any) {
      this.acessosDisponiveis = [];
      this.erro = e?.message || 'Erro ao carregar as permissoes do acesso selecionado.';
    }
  }

  async aoAlterarTipoAlvo(): Promise<void> {
    this.form.codigoAlvo = '';
    this.form.nomeAlvo = '';
    this.filtroPermissao = '';
    this.permissoes = [];
    this.usuariosSelecionados = [];
    this.fecharModalUsuarios();

    if (!this.telaSelecionada) {
      return;
    }

    await this.carregarEntidadesAcessoTela(this.telaSelecionada);
  }

  placeholderCodigoAlvo(): string {
    return this.form.tipoAlvo === 'USUARIO'
        ? 'Codigo do usuario'
        : 'Codigo do grupo';
  }

  placeholderNomeAlvo(): string {
    return this.form.tipoAlvo === 'USUARIO'
        ? 'Digite o nome do usuario'
        : 'Digite o nome do grupo';
  }

  tipoAlvoEhUsuario(): boolean {
    return this.form.tipoAlvo === 'USUARIO';
  }

  alvoLabelSingular(): string {
    return this.tipoAlvoEhUsuario() ? 'usuario' : 'grupo';
  }

  alvoLabelPlural(): string {
    return this.tipoAlvoEhUsuario() ? 'usuarios' : 'grupos';
  }

  alvoLabelPluralTitulo(): string {
    return this.tipoAlvoEhUsuario() ? 'Usuarios' : 'Grupos';
  }

  buscarAlvosAcesso(): void {
    const termo = this.form.nomeAlvo.trim();

    this.form.codigoAlvo = '';

    if (this.buscaAlvoTimer) {
      clearTimeout(this.buscaAlvoTimer);
    }

    if (!this.resourceIdsBuscaAcesso().length) {
      this.dropdownAlvosAberto = false;
      this.erro = 'Selecione uma tela antes de buscar usuario ou grupo.';
      return;
    }

    if (termo.length < 2) {
      this.alvosFiltrados = [];
      this.dropdownAlvosAberto = false;
      return;
    }

    this.buscaAlvoTimer = setTimeout(() => {
      this.carregarAlvosAcesso(termo);
    }, 250);
  }

  async carregarAlvosAcesso(termo: string): Promise<void> {
    const resourceIDs = this.resourceIdsBuscaAcesso();

    if (!resourceIDs.length) {
      return;
    }

    this.buscandoAlvos = true;
    this.dropdownAlvosAberto = true;

    try {
      const res = await firstValueFrom(
          this.gateway.listarEntidadesAcessoControleAcesso(
              resourceIDs,
              this.form.tipoAlvo
          )
      );

      const body: any = (res as any)?.responseBody ?? res;

      const lista = this.extrairListaTelasSankhya(body)
          .map((item: any) => this.normalizarAlvoAcesso(item))
          .filter((item: AlvoAcesso) => {
            const texto = `${item.id} ${item.descricao} ${item.agrupamento ?? ''}`.toUpperCase();
            return texto.includes(termo.toUpperCase());
          });

      this.alvosAcesso = lista;
      this.alvosFiltrados = lista;

    } catch (e: any) {
      this.alvosAcesso = [];
      this.alvosFiltrados = [];
      this.erro = e?.message || 'Erro ao buscar usuarios/grupos.';
    } finally {
      this.buscandoAlvos = false;
    }
  }

  selecionarAlvoAcesso(alvo: AlvoAcesso): void {
    this.form.codigoAlvo = String(alvo.id);
    this.form.nomeAlvo = alvo.descricao;
    this.dropdownAlvosAberto = false;
  }

  abrirConfirmarExcluirPermissao(usuario: UsuarioAcessoModal): void {
    if (!this.edicaoAcesso) {
      this.removerUsuarioSelecionado(usuario);
      return;
    }

    this.alvoExclusaoPermissao = usuario;
    this.modalConfirmarExclusaoAberto = true;
  }

  cancelarExcluirPermissao(): void {
    this.modalConfirmarExclusaoAberto = false;
    this.alvoExclusaoPermissao = null;
  }

  async confirmarExcluirPermissao(): Promise<void> {
    const tela = this.telaSelecionada;
    const alvo = this.alvoExclusaoPermissao ?? this.usuariosSelecionados[0];

    if (!tela || !alvo) {
      this.cancelarExcluirPermissao();
      return;
    }

    const resourceID = this.resourceIdTela(tela);

    if (!resourceID) {
      this.modalConfirmarExclusaoAberto = false;
      this.abrirModalAviso('Erro', 'ResourceID da tela nao localizado.');
      return;
    }

    this.salvando = true;

    const payload = {
      permissao: {
        modoAcesso: this.form.tipoAlvo === 'USUARIO' ? 'usuario' : 'grupo',
        itens: {
          item: {
            resourceID
          }
        },
        usuarios: {
          usuario: {
            value: String(alvo.id)
          }
        }
      },
      clientEventList: {}
    };

    try {
      const res: any = await firstValueFrom(
          this.gateway.deletarPermissaoAcessoControleAcesso(payload)
      );

      const status = String(res?.status ?? res?.serviceResponse?.status ?? '1');

      if (status !== '1') {
        this.abrirModalAviso(
            'Erro',
            res?.statusMessage || res?.message || 'Erro ao excluir permissao.'
        );
        return;
      }

      this.cancelarExcluirPermissao();
      this.fecharModalNovoAcesso();
      this.abrirModalAviso('Aviso', 'Permissao excluida com sucesso.');
      await this.carregarEntidadesAcessoTela(tela);
    } catch (e: any) {
      this.abrirModalAviso('Erro', e?.message || 'Erro ao excluir permissao.');
    } finally {
      this.salvando = false;
    }
  }

  private normalizarAlvoAcesso(item: any): AlvoAcesso {
    return {
      id: item.id ?? item.ID ?? '',
      descricao: String(item.descricao ?? item.DESCRICAO ?? item.nome ?? item.NOME ?? ''),
      tipo: String(item.tipo ?? item.TIPO ?? 'usuario').toLowerCase() === 'grupo' ? 'grupo' : 'usuario',
      agrupamento: String(item.agrupamento ?? item.AGRUPAMENTO ?? '')
    };
  }

  async carregarEntidadesAcessoTela(tela: TelaControleAcesso): Promise<void> {
    const resourceID = this.resourceIdTela(tela);

    if (!resourceID) {
      this.permissoes = [];
      return;
    }

    this.carregandoPermissoes = true;
    this.erro = '';
    this.sucesso = '';

    try {
      const res = await firstValueFrom(
          this.gateway.listarEntidadesAcessoControleAcesso([resourceID], this.form.tipoAlvo)
      );
      const body: any = (res as any)?.responseBody ?? res;
      this.permissoes = this.extrairListaTelasSankhya(body).map((p: any) => this.normalizarPermissaoEntidade(p, tela));
    } catch (e: any) {
      this.permissoes = [];
      this.erro = e?.message || 'Erro ao carregar as permissoes desta tela.';
    } finally {
      this.carregandoPermissoes = false;
    }
  }

  async abrirFilhosTela(tela: TelaControleAcesso): Promise<void> {
    const chave = this.chaveTela(tela);
    this.erro = '';
    this.sucesso = '';

    if (this.cacheTelas.has(chave)) {
      this.caminhoTelas = [...this.caminhoTelas, tela];
      this.telasNivelAtual = this.cacheTelas.get(chave) ?? [];
      this.filtroTela = '';
      return;
    }

    this.carregandoTelas = true;
    try {
      const res = await firstValueFrom(this.gateway.listarTelasControleAcesso(tela));
      const body: any = (res as any)?.responseBody ?? res;
      const lista = this.extrairListaTelasSankhya(body)
          .map((item: any) => this.normalizarTelaSankhya(item, this.caminhoTelas.length + 1));

      this.cacheTelas.set(chave, lista);
      this.caminhoTelas = [...this.caminhoTelas, tela];
      this.telasNivelAtual = lista;
      this.filtroTela = '';
    } catch (e: any) {
      this.erro = e?.message || 'Erro ao carregar os itens internos deste m¢dulo.';
    } finally {
      this.carregandoTelas = false;
    }
  }

  voltarNivelTela(): void {
    if (!this.caminhoTelas.length) {
      return;
    }

    const novoCaminho = this.caminhoTelas.slice(0, -1);
    const pai = novoCaminho[novoCaminho.length - 1];

    this.caminhoTelas = novoCaminho;
    this.telasNivelAtual = pai
        ? this.cacheTelas.get(this.chaveTela(pai)) ?? []
        : this.cacheTelas.get('ROOT') ?? this.telas;
    this.filtroTela = '';
  }

  voltarParaNivelTela(indice: number): void {
    if (indice < 0) {
      this.caminhoTelas = [];
      this.telasNivelAtual = this.cacheTelas.get('ROOT') ?? this.telas;
      this.filtroTela = '';
      return;
    }

    const item = this.caminhoTelas[indice];
    this.caminhoTelas = this.caminhoTelas.slice(0, indice + 1);
    this.telasNivelAtual = this.cacheTelas.get(this.chaveTela(item)) ?? [];
    this.filtroTela = '';
  }

  async salvarPermissao(): Promise<void> {
    this.erro = '';
    this.sucesso = '';

    const telasParaSalvar = this.telasSelecionadas.length > 0
        ? this.telasSelecionadas
        : this.telaSelecionada
            ? [this.telaSelecionada]
            : [];

    if (!telasParaSalvar.length) {
      this.abrirModalAviso(
          'Erro ao atualizar permissões',
          'Selecione uma tela.'
      );
      return;
    }

    const itens = telasParaSalvar
        .map((tela) => this.resourceIdTela(tela))
        .filter((resourceID) => !!resourceID)
        .map((resourceID) => ({ resourceID }));

    if (!itens.length) {
      this.abrirModalAviso(
          'Erro ao atualizar permissões',
          'ResourceID das telas selecionadas não localizado.'
      );
      return;
    }

    if (!this.usuariosSelecionados.length) {
      this.abrirModalAviso(
          'Erro ao atualizar permissäes',
          `Informe ao menos um ${this.alvoLabelSingular()}.`
      );
      return;
    }

    if (!this.usuariosSelecionados.length) {
      this.abrirModalAviso(
          'Erro ao atualizar permissões',
          'Informe ao menos um usuário.'
      );
      return;
    }

    if (!this.acessosDisponiveis.length) {
      this.abrirModalAviso(
          'Erro ao atualizar permissões',
          'Nenhuma permissão disponível para salvar.'
      );
      return;
    }

    this.salvando = true;

    try {
      const alvosPayload = this.usuariosSelecionados.map((usuario) => ({
        value: String(usuario.id)
      }));

      const payload = {
        permissao: {
          modoAcesso: this.form.tipoAlvo === 'USUARIO' ? 'usuario' : 'grupo',
          itens: {
            item: itens
          },
          usuarios: {
            usuario: alvosPayload
          },
          acessos: {
            item: this.acessosDisponiveis.map((acesso) => ({
              sigla: acesso.sigla,
              permissao: String(!!acesso.permissao),
              grupo: String(!!acesso.grupo),
              repassar: String(!!acesso.repassar)
            }))
          }
        },
        clientEventList: {}
      };

      const res: any = await firstValueFrom(
          this.gateway.atualizarPermissaoAcessoControleAcesso(payload)
      );

      const status = String(res?.status ?? res?.serviceResponse?.status ?? '1');

      if (status !== '1') {
        this.abrirModalAviso(
            'Erro ao atualizar permissões',
            res?.statusMessage || res?.message || 'Erro ao atualizar permissões.'
        );
        return;
      }

      this.erro = '';
      this.sucesso = '';

      this.fecharModalNovoAcesso();

      this.abrirModalAviso(
          'Aviso',
          'Permissões Atualizadas Com Sucesso.'
      );

      if (this.telaSelecionada) {
        await this.carregarEntidadesAcessoTela(this.telaSelecionada);
      }

    } catch (e: any) {
      this.erro = '';

      this.abrirModalAviso(
          'Erro',
          e?.message || 'Erro ao atualizar permissões.'
      );
    } finally {
      this.salvando = false;
    }
  }

  nomeTelaSelecionada(): string {
    if (this.telasSelecionadas.length > 0) {
      return this.telasSelecionadas.map((tela) => tela.nome).join(' - ');
    }

    return this.telaSelecionada?.nome || this.telas.find(t => t.codigo === this.form.codigoTela)?.nome || 'Selecione uma tela';
  }

  temFilhos(tela: TelaControleAcesso): boolean {
    return String(tela.temFilhos ?? '').toUpperCase() === 'S';
  }

  telaSelecionadaMultipla(tela: TelaControleAcesso): boolean {
    return this.telasSelecionadas.some((item) => item.codigo === tela.codigo);
  }

  async alternarTelaSelecionada(tela: TelaControleAcesso, event: Event): Promise<void> {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      this.telaFocoAcesso = tela;

      if (!this.telaSelecionadaMultipla(tela)) {
        this.telasSelecionadas = [...this.telasSelecionadas, tela];
      }
    } else {
      this.telasSelecionadas = this.telasSelecionadas.filter((item) => item.codigo !== tela.codigo);
      if (this.telaFocoAcesso?.codigo === tela.codigo) {
        this.telaFocoAcesso = this.telasSelecionadas[this.telasSelecionadas.length - 1] ?? null;
      }
    }

    this.telaSelecionada = this.telasSelecionadas[this.telasSelecionadas.length - 1] ?? null;
    this.form.codigoTela = this.telasSelecionadas.map((item) => item.codigo).join(',');

    this.form.codigoAlvo = '';
    this.form.nomeAlvo = '';
    this.alvosAcesso = [];
    this.alvosFiltrados = [];
    this.dropdownAlvosAberto = false;

    if (this.telaSelecionada) {
      await this.carregarPermissoesDisponiveisTela(this.telaSelecionada);
      await this.carregarEntidadesAcessoTela(this.telaSelecionada);
    } else {
      this.acessosDisponiveis = [];
      this.permissoes = [];
    }
  }

  classeIconeTela(tela: TelaControleAcesso): string {
    if (tela.nivel === 0) return 'menu-icon-modulo';
    return this.temFilhos(tela) ? 'menu-icon-pasta' : 'menu-icon-tela';
  }

  private tipoItemMenu(temFilhos: string, nivel: number): 'MODULO' | 'PASTA' | 'TELA' {
    if (nivel === 0) return 'MODULO';
    return temFilhos === 'S' ? 'PASTA' : 'TELA';
  }

  private chaveTela(tela: TelaControleAcesso): string {
    return String(tela.id ?? tela.codigo ?? tela.nome);
  }

  private resourceIdTela(tela: TelaControleAcesso): string {
    return String(
      tela.resourceID ??
      (tela as any).resourceId ??
      (tela as any).RESOURCEID ??
      tela.rota ??
      ''
    ).trim();
  }

  private resourceIdsSelecionados(): string[] {
    const telas = this.telasSelecionadas.length > 0
        ? this.telasSelecionadas
        : this.telaSelecionada
            ? [this.telaSelecionada]
            : [];

    return Array.from(new Set(
        telas
            .map((tela) => this.resourceIdTela(tela))
            .filter((resourceID) => !!resourceID)
    ));
  }

  private resourceIdsBuscaAcesso(): string[] {
    const resourceID = this.telaFocoAcesso
        ? this.resourceIdTela(this.telaFocoAcesso)
        : '';

    return resourceID ? [resourceID] : this.resourceIdsSelecionados();
  }

  fotoPermissao(p: PermissaoControleAcesso): string {
    if (p._fotoErro) {
      return '';
    }

    if (p.fotoUrl) {
      return this.urlSankhya(p.fotoUrl);
    }

    if (p.tipoAlvo === 'USUARIO' && p.codigoAlvo) {
      return this.urlSankhya(`/mge/image/user/${p.codigoAlvo}.jpg`);
    }

    return '';
  }

  iniciaisPermissao(p: PermissaoControleAcesso): string {
    const nome = (p.nomeAlvo || p.codigoAlvo || '?').trim();
    return nome.split(/\s+/).slice(0, 2).map((parte) => parte.charAt(0)).join('').toUpperCase();
  }

  badgeAtivo(ativo: string): string {
    return (ativo || 'S').toUpperCase() === 'S' ? 'badge-ok' : 'badge-off';
  }

  labelAtivo(ativo: string): string {
    return (ativo || 'S').toUpperCase() === 'S' ? 'Ativo' : 'Inativo';
  }

  private normalizarTela(tela: any): TelaControleAcesso {
    return {
      codigo: String(tela.codigo ?? tela.CODIGO ?? tela.rota ?? tela.ROTA ?? ''),
      nome: String(tela.nome ?? tela.NOME ?? tela.descricao ?? tela.DESCRICAO ?? ''),
      rota: String(tela.rota ?? tela.ROTA ?? tela.codigo ?? tela.CODIGO ?? ''),
      modulo: String(tela.modulo ?? tela.MODULO ?? 'GERAL'),
      ativo: String(tela.ativo ?? tela.ATIVO ?? 'S')
    };
  }

  private normalizarPermissao(p: any): PermissaoControleAcesso {
    return {
      id: Number(p.id ?? p.ID ?? p.codigo ?? p.CODIGO ?? 0),
      codigoTela: String(p.codigoTela ?? p.CODTELA ?? p.tela ?? p.TELA ?? ''),
      nomeTela: String(p.nomeTela ?? p.NOMETELA ?? p.telaNome ?? p.TELANOME ?? ''),
      tipoAlvo: String(p.tipoAlvo ?? p.TIPOALVO ?? p.tipo ?? p.TIPO ?? 'GRUPO').toUpperCase() === 'USUARIO' ? 'USUARIO' : 'GRUPO',
      codigoAlvo: String(p.codigoAlvo ?? p.CODALVO ?? p.codGrupo ?? p.CODGRUPO ?? p.codUsu ?? p.CODUSU ?? ''),
      nomeAlvo: String(p.nomeAlvo ?? p.NOMEALVO ?? p.nomeGrupo ?? p.NOMEGRUPO ?? p.nomeUsu ?? p.NOMEUSU ?? ''),
      visualizar: this.flag(p.visualizar ?? p.VISUALIZAR ?? p.consultar ?? p.CONSULTAR),
      incluir: this.flag(p.incluir ?? p.INCLUIR),
      alterar: this.flag(p.alterar ?? p.ALTERAR),
      excluir: this.flag(p.excluir ?? p.EXCLUIR),
      ativo: String(p.ativo ?? p.ATIVO ?? 'S')
    };
  }

  private normalizarPermissaoEntidade(p: any, tela: TelaControleAcesso): PermissaoControleAcesso {
    const id = p.id ?? p.ID ?? p.codigo ?? p.CODIGO ?? '';
    const tipo = String(p.tipo ?? p.TIPO ?? 'usuario').toUpperCase() === 'USUARIO' ? 'USUARIO' : 'GRUPO';

    return {
      id: Number(id || 0),
      codigoTela: tela.codigo,
      nomeTela: tela.nome,
      tipoAlvo: tipo,
      codigoAlvo: String(id),
      nomeAlvo: String(p.descricao ?? p.DESCRICAO ?? p.nome ?? p.NOME ?? ''),
      visualizar: true,
      incluir: false,
      alterar: false,
      excluir: false,
      ativo: 'S',
      agrupamento: String(p.agrupamento ?? p.AGRUPAMENTO ?? ''),
      fotoUrl: String(p.fotoUrl ?? p.FOTOURL ?? p.foto ?? p.FOTO ?? '')
    };
  }

  async abrirModalUsuarios(): Promise<void> {
    if (this.edicaoAcesso) {
      return;
    }

    this.erro = '';
    this.sucesso = '';
    const resourceIDs = this.resourceIdsBuscaAcesso();

    if (!resourceIDs.length) {
      this.erro = 'Selecione uma tela antes de buscar usuários.';
      return;
    }

    this.modalUsuariosAberto = true;
    this.carregandoUsuariosModal = true;
    this.filtroUsuarioModal = '';
    this.usuariosModal = [];
    this.usuariosModalFiltrados = [];

    try {
      const res = await firstValueFrom(
          this.gateway.listarEntidadesAcessoControleAcesso(resourceIDs, this.form.tipoAlvo, true)
      );

      const body: any = (res as any)?.responseBody ?? res;

      this.usuariosModal = this.extrairListaTelasSankhya(body)
          .map((item: any) => this.normalizarUsuarioModal(item));

      this.usuariosModalFiltrados = this.usuariosModal;

    } catch (e: any) {
      this.usuariosModal = [];
      this.usuariosModalFiltrados = [];
      this.erro = e?.message || 'Erro ao buscar usuários.';
    } finally {
      this.carregandoUsuariosModal = false;
    }
  }

  fecharModalUsuarios(): void {
    this.modalUsuariosAberto = false;
    this.filtroUsuarioModal = '';
    this.usuariosModalFiltrados = [];
  }

  filtrarUsuariosModal(): void {
    const termo = this.filtroUsuarioModal.trim().toUpperCase();

    if (!termo) {
      this.usuariosModalFiltrados = this.usuariosModal;
      return;
    }

    this.usuariosModalFiltrados = this.usuariosModal.filter((usuario) => {
      const texto = `${usuario.id} ${usuario.descricao} ${usuario.agrupamento ?? ''}`.toUpperCase();
      return texto.includes(termo);
    });
  }

  selecionarUsuarioModal(usuario: UsuarioAcessoModal): void {
    const jaSelecionado = this.usuariosSelecionados.some((item) => String(item.id) === String(usuario.id));

    if (!jaSelecionado) {
      this.usuariosSelecionados = [...this.usuariosSelecionados, usuario];
    }

    this.form.codigoAlvo = this.usuariosSelecionados.map((item) => String(item.id)).join(',');
    this.form.nomeAlvo = this.usuariosSelecionados.map((item) => item.descricao).join(' - ');

    this.fecharModalUsuarios();
  }

  removerUsuarioSelecionado(usuario: UsuarioAcessoModal): void {
    this.usuariosSelecionados = this.usuariosSelecionados.filter((item) => String(item.id) !== String(usuario.id));

    this.form.codigoAlvo = this.usuariosSelecionados.map((item) => String(item.id)).join(',');
    this.form.nomeAlvo = this.usuariosSelecionados.map((item) => item.descricao).join(' - ');
  }

  private normalizarUsuarioModal(item: any): UsuarioAcessoModal {
    return {
      id: item.id ?? item.ID ?? '',
      descricao: String(item.descricao ?? item.DESCRICAO ?? item.nome ?? item.NOME ?? ''),
      tipo: String(item.tipo ?? item.TIPO ?? 'usuario'),
      agrupamento: String(item.agrupamento ?? item.AGRUPAMENTO ?? '')
    };
  }

  fotoUsuarioModal(usuario: UsuarioAcessoModal): string {
    if (!this.tipoAlvoEhUsuario() || String(usuario.tipo).toLowerCase() === 'grupo') {
      return '';
    }

    if (usuario._fotoErro) {
      return '';
    }

    if (!usuario.id) {
      return '';
    }

    return this.urlSankhya(`/mge/image/user/${usuario.id}.jpg`);
  }

  iniciaisUsuarioModal(usuario: UsuarioAcessoModal): string {
    const nome = String(usuario.descricao || usuario.id || '?').trim();

    return nome
        .split(/\s+/)
        .slice(0, 2)
        .map((parte) => parte.charAt(0))
        .join('')
        .toUpperCase();
  }

  private flag(valor: any): boolean {
    return valor === true || valor === 'S' || valor === 's' || valor === 1 || valor === '1';
  }

  abrirModalAviso(titulo: string, mensagem: string): void {
    this.modalAvisoTitulo = titulo;
    this.modalAvisoMensagem = mensagem;
    this.modalAvisoAberto = true;
  }

  fecharModalAviso(): void {
    this.modalAvisoAberto = false;
    this.modalAvisoTitulo = '';
    this.modalAvisoMensagem = '';
  }
}
